import { render, staticRenderFns } from "./PayWall.vue?vue&type=template&id=3e6cb764&scoped=true&lang=html&"
import script from "./PayWall.vue?vue&type=script&lang=js&"
export * from "./PayWall.vue?vue&type=script&lang=js&"
import style0 from "./PayWall.vue?vue&type=style&index=0&id=3e6cb764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6cb764",
  null
  
)

export default component.exports